
import { language as lan_products} from "./products";

//

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    //分类产品列表
    ...lan_products,    
    // 分类页面缺失404
    CATALOG_NO_FOUND_PAGE_TITLE:"Page not found",
    CATALOG_NO_FOUND_PAGE_CONTENT:"The URL you visited is incorrect or has changed. Please check the link and try again."

};

export { language }